export default __webpack_public_path__ + "assets/images/icon-arrow-left.faa2fc843c5b9f5b7373a343452f6131.svg";